import React from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useAppMeta } from "hooks";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import { useAddSendOutMutation } from "store/services/sendOutApi"; 
import SendOutForm from "./SendOutComponent/SendOutForm";
const SendOutCreateScreen = () => {
  const navigate = useNavigate();

  const breadcrumbs = [
    { title: "Send Out", path: "/app/crm/sendOut/list" },
    { title: "New Send Out" },
  ];

  const [createSendOut, { isLoading: creatingSendOut }] = useAddSendOutMutation();

  const handleAddSendOut = async (data) => {
    try {
      const { _id } = await createSendOut(data).unwrap();
      toast.success("Send Out Created!");
      navigate(`/app/crm/sendOut/${_id}/detail`);
    } catch (error) {
      toast.error(
        error?.data?.message ?? error.message ?? "Could not create Send Out!"
      );
    }
  };

  useAppMeta("New Send Out");

  return (
    <BreadcrumbLayout breadcrumbs={breadcrumbs} isBusy={creatingSendOut}>
      <BreadcrumbLayout.Paper>
        <SendOutForm
          isBusy={creatingSendOut}
          onSubmit={handleAddSendOut}
        />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default SendOutCreateScreen;
